"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProps = exports.setup = exports.open = exports.load = exports.globalReset = exports.destroy = exports.close = void 0;
var _reduxActions = require("redux-actions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PREFIX = 'MODAL_DISPATCHER';
var setup = exports.setup = (0, _reduxActions.createAction)("".concat(PREFIX, "/setup"), function (key, onClose, props, mapActions2Store) {
  return _defineProperty({}, key, {
    onClose: onClose,
    props: props,
    mapActions2Store: mapActions2Store
  });
});
var open = exports.open = (0, _reduxActions.createAction)("".concat(PREFIX, "/open"));
var close = exports.close = (0, _reduxActions.createAction)("".concat(PREFIX, "/close"), function (key, args) {
  return {
    key: key,
    args: args
  };
});
var destroy = exports.destroy = (0, _reduxActions.createAction)("".concat(PREFIX, "/destroy"));
var load = exports.load = (0, _reduxActions.createAction)("".concat(PREFIX, "/load"));
var updateProps = exports.updateProps = (0, _reduxActions.createAction)("".concat(PREFIX, "/updateProps"), function (key, props) {
  return {
    key: key,
    props: props
  };
});
var globalReset = exports.globalReset = (0, _reduxActions.createAction)("".concat(PREFIX, "/globalReset"));